var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66732 1.33301V14.6663M11.334 1.33301V14.6663M1.33398 7.99967H14.6673M1.33398 4.66634H4.66732M1.33398 11.333H4.66732M11.334 11.333H14.6673M11.334 4.66634H14.6673M2.78732 1.33301H13.214C14.0166 1.33301 14.6673 1.98369 14.6673 2.78634V13.213C14.6673 14.0157 14.0166 14.6663 13.214 14.6663H2.78732C1.98466 14.6663 1.33398 14.0157 1.33398 13.213V2.78634C1.33398 1.98369 1.98466 1.33301 2.78732 1.33301Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.4cfbc1a6.svg";
export { ForwardRef as ReactComponent };